import { message } from 'antd';
import 'blob-polyfill';
import translate from 'languageProvider/inline';
import Nprogress from 'nprogress';
import {
  all,
  call, cancelled,
  put, spawn,
  takeLatest,
} from 'redux-saga/effects';
import actions from './actions';
import spreadsheetRequests from './requests';

/**
 * Generate spreadsheet
 * @param {*} action
 */
function* generateSpreadsheetGenerator(action) {
  try {
    yield call(() => {
      Nprogress.start();
    });
    message.info(translate('application.action.excel.loading'));
    const response = yield call(spreadsheetRequests, action.payload);
    yield put({
      type: actions.SPREADSHEET_GENERATE_DONE,
      payload: {
        applicationIds: action.payload.applicationIds,
      },
    });
    yield call(() => {
      Nprogress.done();
    });
    yield call(() => {
      message.success(translate('zip.message.success'));
    });
  } catch (e) {
    log(e);
    yield put({ type: actions.SPREADSHEET_GENERATE_ERROR });
    yield call(() => {
      message.success(translate('zip.message.error'));
    });
  } finally {
    if (yield cancelled()) {
      yield put({
        type: actions.SPREADSHEET_GENERATE_CANCELLED,
      });
    }
  }
}

/* zip application filters sada */
export function* generateSpreadsheet() {
  yield takeLatest([actions.SPREADSHEET_GENERATE_START], generateSpreadsheetGenerator);
}

export default function* rootSaga() {
  yield all([spawn(generateSpreadsheet)]);
}
